import type { Proforma } from "@/lib/proforma.api";
import { cn } from "@/lib/utils";
import { STATUS_LABELS, STATUS_STYLES } from "../proforma.constants";

export function ProformaStatusBadge({ status }: { status: Proforma["status"] }) {
  return (
    <span
      className={cn(
        "inline-flex rounded border px-2 py-0.5 text-[10.5px] font-semibold",
        STATUS_STYLES[status],
      )}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
